<template>
  <div>
    <b-modal
      id="main-modal"
      :title="modalTitle"
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
      :hide-header-close="true"
      ref="sign-widget"
      body-class="widget-body"
    >
      <template v-slot:modal-header>
        <button
          type="button"
          class="close"
          aria-label="Close"
          @click="closeModal"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">{{ modalTitle }}</h4>
      </template>

      <router-view
        ref="sign-widget-content"
        name="content"
        :mediator="mediator"
      />

      <template v-slot:modal-footer>
        <div class="sign-widget-buttons">
          <router-view
            ref="sign-widget-buttons"
            name="buttons"
            :mediator="mediator"
          />
          Поддержка сервиса: <br>
          <a href="https://konversta.com/ru/help/signature/" target="_blank" class="widget-button-left konversta-link">
            <img src="../../../../public/img/konversta.png" alt style="width: 120px;">
          </a>
        </div>
        <div style="color:#aaa;margin-top: 10px;text-align: center;" class="widget-right">
          Продолжая использовать сайт, вы&nbsp;даете согласие на&nbsp;обработку файлов cookie. <br/> Ознакомьтесь
          с&nbsp;<a href="https://konversta.com/ru/policy/">Политикой в&nbsp;отношении обработки персональных данных</a>.
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>

import WidgetButtonsEnum from '../enums/WidgetButtonsEnum'
import { Mediator } from '../classes/Mediator'

export default {
  name: 'Widget',

  props: {
    modalTitle: {
      type: String,
      default: 'Электронная подпись'
    }
  },

  data: () => ({
    mediator: null
  }),

  computed: {
    successMessage () {
      return 'Заявка подписана'
    },

    unsuccessMessage () {
      return 'При подписании возникла ошибка'
    }
  },

  methods: {
    showModal () {
      this.$refs['sign-widget'].show()
    },

    closeModal () {
      window.close()
    }
  },

  async mounted () {
    this.mediator = new Mediator(this.$refs)
    this.$root.$on(WidgetButtonsEnum.closeButton.eventName, this.closeModal)
    this.showModal()
  }
}
</script>
